var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',[_vm._v("Settings")]),_c('p',[_vm._v(" Configure various settings relating to your profile ")]),_c('PageTitleDivider'),_c('UserProfile',{staticClass:"my-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }